//Package imports
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import _ from "lodash";
import { makeStyles } from "@material-ui/core/styles";
import { List, Typography } from "@mui/material";
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import PauseIcon from "@mui/icons-material/Pause";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import { unicodeToString } from "../../../Js/Common";
import AudioButton from "../../Media/AudioButton";
import OptionMedia from "./OptionMedia";

import MCQOption from "./ActionComponents/MCQOption";
import TFOption from "./ActionComponents/TFOption";
import DICOption from "./ActionComponents/DICOption";
import ImageModal from "../../Modal/ImageModal";
import StatusIndicator from "./StatusIndicator";

// Global variables

// Component
function OptionsCard(props) {
  let [currentIndexPlay, setCurrentIndexPlay] = useState([]);
  const classes = useStyles();

  const setPlayMode = (status, index, end) => {
    if (status == true && !end && !currentIndexPlay[index]) {
      let arr = new Array(+props.totalOptions).fill(false);
      arr[index] = status;
      setCurrentIndexPlay(arr);
    }
    if (currentIndexPlay[index] || end) {
      let arr = new Array(+props.totalOptions).fill(false);
      setCurrentIndexPlay(arr);
    }
  };

  // JSX template
  return (
    <>
      <List
        dense
        sx={{
          border: 1,
          borderRadius: 10,
          borderColor:
            props.selected && props.assetType != "TF" ? "#DB8829" : "#EFEFEF",
          padding: "0.2em",
          my: 2,
          margin: "0.5em",
        }}
      >
        <ListItem
          sx={{ pa: 0 }}
          secondaryAction={
            <>
              {props.assetType == "MC" && (
                <MCQOption
                  selected={props.selected}
                  press={() => {
                    props.press(props.index);
                  }}
                ></MCQOption>
              )}
              {props.assetType == "TF" && (
                <TFOption
                  selected={props.selected}
                  press={(flag) => {
                    props.press(props.index, flag);
                  }}
                  statePair={props.statePair}
                ></TFOption>
              )}
            </>
          }
        >
          {props.optionWiseAns != undefined && (
            <ListItemIcon>
              <StatusIndicator correct={props.optionWiseAns}></StatusIndicator>
            </ListItemIcon>
          )}
          {props && props.media && (
            <OptionMedia
              media={props.media}
              isPlaying={currentIndexPlay[props.index]}
              setPlayMode={(status, end) => {
                setPlayMode(status, props.index, end);
              }}
            ></OptionMedia>
          )}
          <ListItemText
            classes={{ primary: classes.ListItemText }}
            sx={{ color: "primary.main", pl: 1 }}
          >
            {props && props.text && (
              <Typography
                sx={{
                  width: "calc(70%)",
                  fontWeight: "500",
                  fontSize: "0.9rem",
                  "@media (min-width: 1636px)": {
                    fontSize: "1.4rem",
                  },
                }}
              >
                {unicodeToString(props.text)}
              </Typography>
            )}
            {props.assetType == "DIC" && (
              <DICOption
                changeText={(text) => {
                  props.changeText(text);
                }}
                value={props.value}
                editable={props.editable}
              ></DICOption>
            )}
          </ListItemText>
        </ListItem>
      </List>
    </>
  );
}

// Style
const useStyles = makeStyles({
  ListItemText: {
    fontSize: "1rem",
    "@media (min-width: 1636px)": {
      fontSize: "1.4rem",
    },
  },
  scrollBar: {
    "&::-webkit-scrollbar": {
      width: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
  scrollBarHeight: {
    "&::-webkit-scrollbar": {
      height: "0.2em",
    },
    "&::-webkit-scrollbar-track": {
      backgroundColor: "#ffe600ff",
      "-webkit-box-shadow": "inset 0 0 6px rgba(0,0,0,0.00)",
      borderRadius: 5,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "#5f5600ff",
      borderRadius: 5,
    },
  },
});

export default OptionsCard;
